var map = {
	"./da-DK.json": [
		85965,
		965
	],
	"./de-DE.json": [
		71219,
		219
	],
	"./el-GR.json": [
		95671,
		671
	],
	"./en-GB.json": [
		86573,
		573
	],
	"./en-MY.json": [
		11290,
		290
	],
	"./en-US.json": [
		70872,
		872
	],
	"./es-ES.json": [
		88357,
		357
	],
	"./fa-IR.json": [
		82425,
		425
	],
	"./fi-FI.json": [
		12235,
		235
	],
	"./fr-FR.json": [
		70085,
		85
	],
	"./hr-HR.json": [
		96469,
		469
	],
	"./it-IT.json": [
		94443,
		443
	],
	"./ko-KR.json": [
		82898,
		898
	],
	"./lt-LT.json": [
		75769,
		769
	],
	"./nb-NO.json": [
		42910,
		910
	],
	"./pl-PL.json": [
		74081,
		81
	],
	"./ro-RO.json": [
		49675,
		675
	],
	"./sv-SE.json": [
		22378,
		378
	],
	"./tr-TR.json": [
		28613,
		613
	],
	"./vi-VN.json": [
		10102,
		102
	],
	"./zh-SG.json": [
		95485,
		485
	],
	"./zh-TW.json": [
		98718,
		718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40125;
module.exports = webpackAsyncContext;